(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["houselife-b2b-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.hl-b2b-product__thumb');
    if (!thumb) return;
    const gallery = thumb.closest('[data-b2b-gallery]');
    const image = gallery && gallery.querySelector('.hl-b2b-product__main-media img');
    if (!image) return;
    image.src = thumb.dataset.full;
    image.removeAttribute('srcset');
    gallery.querySelectorAll('.hl-b2b-product__thumb').forEach((button) => button.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
